import { render, staticRenderFns } from "./Prevalence.vue?vue&type=template&id=1a54e740&scoped=true&"
import script from "./Prevalence.vue?vue&type=script&lang=js&"
export * from "./Prevalence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a54e740",
  null
  
)

export default component.exports